import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaTituloDesvios from '../../../../../lib/json/consultas/TituloDesvios.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import {ConsultaAPI} from "../../../../../backend/ConsultaAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { ConsumoAPI_DELETE } from "../../../../../backend/ConsumoAPI";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../../../App";
import { usePopUp } from "../../../../components/BootBox";

function ListaTituloDesvios(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
        },
        {
            Header: 'Nome',
            accessor: 'Nome',
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var consultaDefault  = ConsultaTituloDesvios.consulta;
    var [data, setData]   = useState([]);
    
    useEffect(() => {
        loadListaTituloDesvios();
    }, []);

    // Processa consulta do grid
    const loadListaTituloDesvios = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaAPI( consultaDefault );
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - ' + row.values.Nome}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);

            const rota = 'titulosDesvios/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);

            SucessoMsg(retConsumo.description);
            loadListaTituloDesvios();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };
    
    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Título Desvios"/>
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadListaTituloDesvios}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaTituloDesvios;